/**
 * EM: Hide Pandectes floating cookie widget while Stretch drawers/modals are open.
 * Stretch sets `html.lock` when cart/menu/search drawers open.
 */
(function () {
  function syncPandectesWidget() {
    var locked = document.documentElement.classList.contains('lock');
    document.querySelectorAll('pandectes-cmp').forEach(function (host) {
      var root = host.shadowRoot;
      if (!root) return;
      var widget = root.querySelector('button.widget');
      if (!widget) return;
      widget.style.setProperty('visibility', locked ? 'hidden' : 'visible', 'important');
      widget.style.setProperty('opacity', locked ? '0' : '1', 'important');
      widget.style.setProperty('pointer-events', locked ? 'none' : 'auto', 'important');
    });
  }

  var htmlObserver = new MutationObserver(syncPandectesWidget);
  htmlObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class']
  });

  var treeObserver = new MutationObserver(syncPandectesWidget);
  treeObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPandectesWidget);
  } else {
    syncPandectesWidget();
  }
})();

/**
 * EM: Hide collection "Filtern & sortieren" floating button when the footer group
 * (newsletter apps section sits above .shopify-section--footer) enters the viewport.
 * Stock theme only watches the footer section, so the button overlays the newsletter.
 */
(function () {
  function footerGroupStart() {
    var footer = document.querySelector('.shopify-section--footer');
    if (!footer) return null;
    var parent = footer.parentElement;
    if (parent) {
      var first = parent.querySelector('.shopify-section');
      if (first) return first;
    }
    return footer;
  }

  function initFloatingFilterHide() {
    var end = footerGroupStart();
    var buttons = document.querySelectorAll('collection-facets-floating-button');
    if (!end || !buttons.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var hide = entry.isIntersecting && entry.boundingClientRect.top < window.innerHeight;
        buttons.forEach(function (btn) {
          btn.classList.toggle('em-hide-near-footer', hide);
        });
      });
    }, { threshold: 0 });

    io.observe(end);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFloatingFilterHide);
  } else {
    initFloatingFilterHide();
  }
})();

/**
 * EM: Cart-drawer donation checkbox — add/remove linked product (qty 1).
 * Relies on Stretch cart:prepare-bundled-sections + cart:change for drawer refresh.
 */
(function () {
  if (window.customElements.get('em-cart-donation')) return;

  class EmCartDonation extends HTMLElement {
    connectedCallback() {
      this._onChange = this._onChange.bind(this);
      this._checkbox = this.querySelector('#em-cart-donation-checkbox');
      if (this._checkbox) {
        this._checkbox.addEventListener('change', this._onChange);
      }
    }

    disconnectedCallback() {
      if (this._checkbox) {
        this._checkbox.removeEventListener('change', this._onChange);
      }
    }

    async _onChange(event) {
      var checkbox = event.target;
      var wantInCart = checkbox.checked;
      var currentlyInCart = this.getAttribute('data-in-cart') === 'true';
      if (wantInCart === currentlyInCart) return;

      checkbox.disabled = true;
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      try {
        if (wantInCart) {
          await this._addDonation();
        } else {
          await this._removeDonation();
        }
      } catch (err) {
        checkbox.checked = currentlyInCart;
        console.error('[em-cart-donation]', err);
      } finally {
        checkbox.disabled = false;
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }
    }

    async _addDonation() {
      var variantId = this.getAttribute('data-variant-id');
      if (!variantId) throw new Error('Missing variant id');

      var sectionsToBundle = new Set();
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );

      var response = await fetch(Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: Array.from(sectionsToBundle).join(',')
        })
      });

      var responseJson = await response.json();
      if (!response.ok) {
        throw new Error(responseJson.description || responseJson.message || 'Add failed');
      }

      var cartContent = await (await fetch(Shopify.routes.root + 'cart.js')).json();
      cartContent.sections = responseJson.sections;

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'em-cart-donation:add', cart: cartContent }
        })
      );
    }

    async _removeDonation() {
      var lineKey = this.getAttribute('data-line-key');
      if (!lineKey) throw new Error('Missing line key');

      var sectionsToBundle = new Set();
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );

      var response = await fetch(Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0,
          sections: Array.from(sectionsToBundle).join(',')
        })
      });

      var cartContent = await response.json();
      if (!response.ok) {
        throw new Error(cartContent.description || cartContent.message || 'Remove failed');
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'em-cart-donation:remove', cart: cartContent }
        })
      );
    }
  }

  window.customElements.define('em-cart-donation', EmCartDonation);
})();
